type pluralProps = {
  replacement?: string,
  suffix?: string
}

export function pluralize( count: number, noun: string, {replacement, suffix = 's'}: pluralProps = {} ) {
  const complement = count !== 1 ? (replacement ? replacement : noun + suffix) : noun

  return `${count} ${complement}`
}
